var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.43644 0.763604C5.78792 1.11508 5.78792 1.68492 5.43644 2.0364L2.47284 5L5.43644 7.9636C5.78792 8.31508 5.78792 8.88492 5.43644 9.2364C5.08497 9.58787 4.51512 9.58787 4.16365 9.2364L0.563653 5.6364C0.212181 5.28492 0.212181 4.71508 0.563653 4.3636L4.16365 0.763604C4.51512 0.412132 5.08497 0.412132 5.43644 0.763604Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.d41b4ce305dae3eff782cfeae5b26ac7.svg";
export { ForwardRef as ReactComponent };